import { z } from 'zod';
import { createStandardResponse } from '@/src/shared/data/schemas/responses/base';

export const SChatContact = z.object({
  id: z.int(),
  name: z.string(),
  pubsub_token: z.string(),
});
export type TChatContact = z.infer<typeof SChatContact>;
export const SChatContactResponse = createStandardResponse(SChatContact);
export type TChatContactResponse = z.infer<typeof SChatContactResponse>;
